import { render, staticRenderFns } from "./editorImage.vue?vue&type=template&id=1a7c2d48&scoped=true&"
import script from "./editorImage.vue?vue&type=script&lang=js&"
export * from "./editorImage.vue?vue&type=script&lang=js&"
import style0 from "./editorImage.vue?vue&type=style&index=0&id=1a7c2d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c2d48",
  null
  
)

export default component.exports